import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatDialog } from 'src/app/SayTS/directives/float-dialog';
import { ShowFileDirective } from 'src/app/SayTS/directives/show-file';

@Component({
  selector: 'app-file-float-modal',
  templateUrl: './file-float-modal.component.html',
  styleUrls: ['./file-float-modal.component.scss'],
  imports: [CommonModule, FloatDialog, ShowFileDirective]
})
export class FileFloatModalComponent implements OnInit {

  @Input() showType: string = null
  @Input() showHref: string = null

  isOpen: boolean = false
  fullscreen: boolean = false

  constructor() {
  }
  
  ngOnInit(): void {
  }

  open() {
    this.isOpen = true
  }

  close() {
    this.isOpen = false
    this.showHref = null
  }
}
